<script setup lang="ts">
import type { EsProduct } from '~/types/elastic'
import { AppLink } from '#components'

export type Props = {
  product: EsProduct
}

const { public: config } = useRuntimeConfig()
const props = defineProps<Props>()

const image = computed<string | null>(() =>
  props.product.brand?.swatch ? config.xcdnUrl + props.product.brand?.swatch : null,
)
</script>

<template>
  <AppLink
    v-if="product.brand"
    :to="'/merken/' + stringToSlug(product.brand?.label)"
    class="label label--brand"
  >
    <img
      v-if="image"
      :src="image"
      :alt="product.brand.label"
    >
    <span v-else>
      {{ product.brand.label }}
    </span>
  </AppLink>
</template>
